import _ from 'lodash'
import SLIDER_HISTORY_CONFIG from './config'
import Flickity from 'flickity-fade'
import imagesLoaded from 'imagesloaded'

class SliderHistoryClass {
    constructor() {
        this.DOM = {
            section: SLIDER_HISTORY_CONFIG.section,
            slider: SLIDER_HISTORY_CONFIG.slider
        }

        this.flckty = null

        this.DOM.section ? this.init() : null
    }

    init() {
        this._flckty()
    }

    _flckty() {
        imagesLoaded( this.DOM.section, () => {
            this.flckty = new Flickity( this.DOM.slider, {
                prevNextButtons: false,
                pageDots: false,
                fade: false,
                cellAlign: 'left'
            })
        })
    }
}

const SLIDER_HISTORY = new SliderHistoryClass()
export default SLIDER_HISTORY